module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/othertransaction/othertransaction.component.css
// module id = ./src/app/othertransaction/othertransaction.component.css
// module chunks = main